import { ChangeDetectionStrategy, Component, DestroyRef, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PreloaderColor } from '@enums/shared.enum';
import * as OrganizationActions from '@states/organization/organization.actions';
import * as InviteActions from '@states/invite/invite.actions';
import { Store } from '@ngrx/store';
import { AppState } from '../../store/app.state';
import { OrganizationEffect } from '@effects/organization.effect';
import { ofType } from '@ngrx/effects';
import { routerSegments } from '@consts/routes';
import { LocalStorageService, SessionStorageService } from '@ui';
import { UniversalLoginService } from '../../authentication/universal-login.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-no-auth',
  templateUrl: './no-auth.component.html',
  styleUrls: ['./no-auth.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class NoAuthComponent implements OnInit {
  public preloaderColor = PreloaderColor;
  public inviteId: string;
  private orgId: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private store$: Store<AppState>,
    private organizationEffect: OrganizationEffect,
    private localStorageService: LocalStorageService,
    private sessionStorageService: SessionStorageService,
    private universalLoginService: UniversalLoginService,
    private destroyRef: DestroyRef,
  ) {
  }

  ngOnInit(): void {
    this.organizationEffect.checkIfUserSigned$
      .pipe(takeUntilDestroyed(this.destroyRef), ofType(OrganizationActions.checkIfUserSignedSuccess))
      .subscribe(res => {
        const access_token = this.localStorageService.getItemWithCheck('access_token');
        if (!!res.orgId) {
          this.orgId = res.orgId;
          if (!res.user) {
            this.universalLoginService.redirectToSignUp(
              window.location.origin,
              this.inviteId,
              res.email,
            );
          } else {
            if (access_token) {
              this.store$.dispatch(InviteActions.acceptInvite({ id: this.inviteId }));
            } else {
              this.universalLoginService.redirectToLogin(
                window.location.origin,
                this.inviteId,
                res.email,
              );
            }
          }
        }
      });

    this.organizationEffect.sendAcceptInvite$
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        ofType(InviteActions.sendAcceptSuccess),
      )
      .subscribe(() => {
        this.sessionStorageService.clear();
        this.router.navigate([routerSegments.location]);
      });


    this.organizationEffect.acceptInviteNoAuth$
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        ofType(InviteActions.acceptInviteNoAuthSuccess),
      )
      .subscribe(() => {
        this.sessionStorageService.clear();
        this.universalLoginService.redirectToLogin();
      });

    this.route.queryParams.pipe()
      .subscribe(res => {
        if (res['login']) {
          this.universalLoginService.redirectToLogin();
        } else {
          this.inviteId = res['inviteId'];
          this.store$.dispatch(OrganizationActions.checkIfUserSigned({ inviteId: res['inviteId'] }));
        }
      });
  }

  public login() {
    this.universalLoginService.redirectToLogin();
  }
}
